/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_Status_PassedInputs */

const en_academy_status_passed = /** @type {(inputs: Academy_Status_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passed`)
};

const ja_academy_status_passed = /** @type {(inputs: Academy_Status_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合格`)
};

const fr_academy_status_passed = /** @type {(inputs: Academy_Status_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réussi`)
};

const de_academy_status_passed = /** @type {(inputs: Academy_Status_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestanden`)
};

/**
* | output |
* | --- |
* | "Passed" |
*
* @param {Academy_Status_PassedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const academy_status_passed = /** @type {((inputs?: Academy_Status_PassedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_Status_PassedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_status_passed(inputs)
	if (locale === "ja") return ja_academy_status_passed(inputs)
	if (locale === "fr") return fr_academy_status_passed(inputs)
	return de_academy_status_passed(inputs)
});